import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import reducers from './reducers/reducers'
//containers
import Navbar from './containers/navbar/NavBar';
import Footer from './containers/footer/Footer';
//Routes
import Landing from './routes/Landing';
import Products from './routes/Products';
import Industries from './routes/Industries';
import HomeandOffice from './routes/HomeandOffice';
import Automotive from './routes/Automotive';
import Health from './routes/Health';
import Informative from './routes/Informative';
import Outdoor from './routes/Outdoor';
import Intelligence from './routes/Intelligence';
import Pricing from './routes/Pricing';
import Developers from './routes/Developers';
import HelpAndGuides from './routes/HelpAndGuides';
import HowToGetAircheckrToken from './routes/help-and-guides/HowToGetAircheckrToken';
import FirstStepsWithTheAircheckrApi from './routes/help-and-guides/FirstStepsWithTheAircheckrApi';
import WhatIsAirPollution from './routes/help-and-guides/WhatIsAirPollution';
import TheSilentKiller from './routes/help-and-guides/TheSilentKiller';
import AirPollutionAndTheCurse from './routes/help-and-guides/AirPollutionAndTheCurse';
import DoMyCustomersWantAirQualityInfo from './routes/help-and-guides/DoMyCustomersWantAirQualityInfo';
import ThereIsHope from './routes/help-and-guides/ThereIsHope';
import PersonalisedRecommendations from './routes/help-and-guides/PersonalisedRecommendations';
import OurStory from './routes/OurStory';
import PressKit from './routes/PressKit';
import Pers from './routes/Pers';
import Contact from './routes/Contact';
import Signup from './routes/Signup';
import Auth from './containers/Auth';
import Confirm from './routes/Confirm';
import ResetPass from './routes/ResetPass';
import NoMatch from './routes/NoMatch';
//scroll handler
import ScrollToTop from './helpers/ScrollToTop';
//css
import 'bootstrap/dist/css/bootstrap.css';
import './index.styl';

class App extends React.Component {
  render(){
    return (
      <Router>
        <Provider store={ createStore(reducers) }>
          <ScrollToTop>
            <div className="page-wrapper">
              <Navbar />
              <Switch>
                <Route exact path='/' render={ () => <Landing lang='en' /> } />
                <Route exact path='/nl' render={ () => <Landing lang='nl' /> } />
                <Route exact path='/products' render={ () => <Products lang='en' /> } />
                <Route exact path='/nl/products' render={ () => <Products lang='nl' /> } />
                <Route exact path='/industries' render={ () => <Industries lang='en' /> } />
                <Route exact path='/nl/industries' render={ () => <Industries lang='nl' /> } />
                  <Route exact path='/industries/homeandoffice' component={HomeandOffice} />
                  <Route path='/industries/info' component={Informative} />
                  <Route path='/industries/outdoor' component={Outdoor} />
                  <Route exact path='/industries/health' component={Health} />
                  <Route exact path='/industries/auto' component={Automotive} />
                  <Route path='/industries/intelli' component={Intelligence} />
                <Route path='/pricing' render={ () => <Pricing lang='en' /> } />
                <Route path='/nl/pricing' render={ () => <Pricing lang='nl' /> } />
                <Route path='/developers' render={ () => <Developers lang='en' /> } />
                <Route path='/nl/developers' render={ () => <Developers lang='nl' /> } />
                <Route exact path='/help-and-guides' component={HelpAndGuides} />
                  <Route exact path='/help-and-guides/how-to-get-an-aircheckr-access-token' component={HowToGetAircheckrToken} />
                  <Route exact path='/help-and-guides/first-steps-with-the-aircheckr-api' component={FirstStepsWithTheAircheckrApi} />
                  <Route exact path='/help-and-guides/what-is-air-pollution' component={WhatIsAirPollution} />
                  <Route exact path='/help-and-guides/the-silent-killer' component={TheSilentKiller} />
                  <Route exact path='/help-and-guides/air-pollution-and-the-curse' component={AirPollutionAndTheCurse} />
                  <Route exact path='/help-and-guides/do-my-customers-really-want-air-quality-info' component={DoMyCustomersWantAirQualityInfo} />
                  <Route exact path='/help-and-guides/there-is-hope' component={ThereIsHope} />
                  <Route exact path='/help-and-guides/personalised-recommendations' component={PersonalisedRecommendations} />
                <Route path='/our-story' component={OurStory} />
                <Route path='/press' component={PressKit} />
                <Route path='/pers' component={Pers} />
                <Route path='/contact' component={Contact} />
                <Route path='/signup' component={Signup} />
                <Route path='/login' component={Auth} />
                <Route path='/resetpass' component={ResetPass} />
                <Route path='/dashboard' component={Auth} />
                <Route path='/confirm' component={Confirm} />
                <Route component={NoMatch} />
              </Switch>
              <Footer />
            </div>
          </ScrollToTop>
        </Provider>
      </Router>
    );
  }
};

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js